<template>
  <v-container fluid>
    <v-toolbar flat color="#FAFAFA">
      <v-btn icon outline color="black" to="/produtos">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title >{{getToolbarTitle()}}</v-toolbar-title>
      <v-spacer></v-spacer>
      
      <!--v-btn color="success" >Salvar</v-btn-->
    </v-toolbar>

    <template>
      <v-stepper v-model="e1" non-linear>
        <v-stepper-header>
          <v-stepper-step editable complete  step="1">Informações do Produto</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step complete editable step="2">Informações das Faixas</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <album_info
              ref="album_info"
              :product="product"
              @cover_change="cover_change"
              @product_change="product_changed"
            />

            <v-btn color="primary" @click="validate_album_info()">Gerenciar Faixas</v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <keep-alive>
              <faixas_info ref="faixas_info" :tracks="tracks" @track_change="tracks_changed" />
            </keep-alive>

            <v-btn color="primary" @click="validate_faixas_info()">Salvar</v-btn>

            <v-btn flat @click="e1 = 1">Voltar</v-btn>
          </v-stepper-content>

          <!--v-stepper-content step="3">            
            <plataformas ref="plataformas" />
            <v-btn color="primary" @click="e1 = 1">Continuar</v-btn>
            <v-btn flat>Cancel</v-btn>
          </v-stepper-content-->
        </v-stepper-items>
      </v-stepper>
    </template>

    <!-- Dialog -->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Produto finalizado</v-card-title>

        <v-card-text>Metadados cadastrados!</v-card-text>

        <v-card-actions>
          <v-btn color="green darken-1" flat="flat" @click="dialog_close()">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
import album_info from "../../components/produtos/album_info";
import faixas_info from "../../components/produtos/faixas_info";
import plataformas from "../../components/produtos/plataformas";
import ProductService from "../../app/Rest/product";
import { Promise, reject } from "q";

var productService = null;

export default {
  components: {
    album_info,
    faixas_info,
    plataformas
  },
  data() {
    return {
      editable_product: null,
      dialog: false,
      e1: 1,
      product: {},
      tracks: [],
      cover_file: null
    };
  },
  beforeCreate: function() {
      productService = ProductService.build();
      if( this.$route.params )
        this.editable_product = this.$route.params.id == undefined? false: this.$route.params.id;

    
    if(!this.editable_product){
      return;
    }
    this.$store.dispatch("loading_full");
    productService.getOne(this.editable_product).then(e => {
      if (e.items) {
        this.product = e.items.product;
        this.tracks = e.items.tracks;
        this.$refs.faixas_info.faixas = this.tracks;
        this.$store.dispatch("loading_full");
      }
    });
  },
  methods: {
    dialog_close() {
      this.$router.push("/produtos");
    },
    cover_change(cover) {
      console.log("cover_changed", cover);
      this.cover_file = cover;
    },
    product_changed(product) {
      this.product = product;
    },
    tracks_changed(tracks) {
      console.log("faixas alteradas");
      console.log(tracks);
      this.tracks = tracks;
    },
    save_album_info() {
      console.log("salvar_album_info", this.cover_file);
      return new Promise((resolve, reject) => {
        this.product.tracks = this.tracks;
        productService
          .salvar(this.product)
          .then(e => {
            if (e.items) {
              //retorna o produto atualizado
              this.product = e.items.product;
              this.tracks = e.items.tracks;
              if (!this.cover_file) {
                return resolve();
              }
              this.editable_product = this.product.id;
              productService
                .sendCover({
                  product_id: this.product.id,
                  cover: this.cover_file
                })
                .then(ee => {
                  resolve();
                });
            }
          })
          .catch(e => {
            //@todo exbir caixa de dialogo dizendo que não conseguiu salvar
            console.log("erro ao salvar");
            console.log(e);
            reject();
            this.$store.dispatch("loading_full");
          });
      });
    },

    validate_album_info() {
      this.$refs.album_info.submit().then(isValid => {
        if (isValid) {
          //this.product = this.$refs.album_info.product;
          this.$store.dispatch("loading_full");
          this.save_album_info()
            .then(e => {
              this.e1 = 2;
              this.$store.dispatch("loading_full");
            })
            .catch(e => {
              this.$store.dispatch("loading_full");
            });
        }
      });
    },

    validate_faixas_info() {
      this.$refs.faixas_info.submit().then(isValid => {
        if (isValid) {
          //;
          this.$store.dispatch("loading_full");
          this.save_album_info().then(e => {
            this.$store.dispatch("loading_full");
            this.dialog = true;
          });
        }
      });
    },

    /**
     * Controla a exibição de titulo da toolbar
     */
    getToolbarTitle() {
      var title = "Novo Produto ";

      if (this.product.status) {
        title = this.product.name + " (" + this.product.status + ")";
      }

      return title;
    }
  }
};
</script>